// extracted by mini-css-extract-plugin
module.exports = {"card":"_1lhEh4OrcEnvYdtD0CzSmf","divider":"_3DLYHx4lIU79hP_JpnI5RC"};